import type { Href } from 'expo-router'
import { UnimpersonateUrlHandler } from '../src/zportiAdmin/components/UnimpersonateUrlHandler/UnimpersonateUrlHandler'

/**
 * Marketing-site parity with `/site-impersonate`: end read-only impersonation
 * then replace to `/` (operators on `/` are not forced into `/app` to exit).
 */
export default function WebsiteUnimpersonateRoute() {
  return <UnimpersonateUrlHandler afterReplaceHref={'/' as Href} />
}
